import request from '@/utils/request'

// 查询韩国TBT通报列表
export function listHgTbtReport(query) {
  return request({
    url: '/web/zlts/hgTbtReport/list',
    method: 'get',
    params: query
  })
}